// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend'; // For loading translations over a network
// import LanguageDetector from 'i18next-browser-languagedetector'; // For detecting user language

i18n
    .use(initReactI18next) // Passes i18n instance to react-i18next
    .use(HttpBackend)      // Allows loading translations over a network
    // .use(LanguageDetector) // Automatically detects the user's language
    .init({
        fallbackLng: 'en', // Use English if the detected language is not available
        debug: false,       // Set to false in production
        interpolation: {
            escapeValue: false, // Not needed for React as it escapes by default
        },
        backend: {
            // Configuration options for the backend. Here, you would specify your server settings or local files.
            loadPath: '/locales/{{lng}}/{{ns}}.json' // Path to your language files
        }
    });

export default i18n;
